<template>
    <div class="login-page">
        <div class="login-container">
            <!-- Header avec logo texte -->
            <div class="login-header">
                <router-link :to="{ name: 'trips' }" class="logo-link">
                    <h1 class="app-name">MyEcoCar</h1>
                </router-link>
                <p class="login-subtitle">{{ $t('iniciarSesion') }}</p>
                </div>

            <!-- Formulaire de connexion -->
            <div class="login-form">
                <div class="alert alert-warning" role="alert" v-if="!isUnderstood">
                    {{ $t('recuperarDeFacebook') }}
                    <a :href="'mailto:' + config.admin_email">{{
                        $t('carpoolearMail')
                    }}</a>
                    {{ $t('recuperarDeFacebook2') }}
                    <div class="row form-inline form-warning-login">
                        <div class="col-sm-24 text-right">
                            <div class="checkbox">
                                <label>
                                    <input
                                        type="checkbox"
                                        v-model="dontShowAgain"
                                    />
                                    <span>{{ $t('noMostrar') }}</span>
                                </label>
                            </div>
                            <button
                                type="button"
                                class="btn btn-default"
                                @click="fbWarningGetIt"
                            >
                                {{ $t('entendido') }}
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Champ Email -->
                <div class="form-group">
                    <label for="txt_user">{{ $t('email') }}</label>
                    <input
                        :placeholder="$t('loginUsuarioPlaceholder')"
                        ref="txt_user"
                        type="email"
                        id="txt_user"
                        class="form-input"
                        v-model="email"
                        v-jump
                    />
                </div>

                <!-- Champ Mot de passe -->
                <div class="form-group">
                    <label for="txt_password">{{ $t('password') }}</label>
                    <input
                        :placeholder="$t('loginPasswordPlaceholder')"
                        ref="txt_password"
                        type="password"
                        id="txt_password"
                        class="form-input"
                        v-jump
                        v-model="password"
                    />
                </div>

                <!-- Messages d'alerte -->
                <div
                    class="alert alert-info"
                    role="alert"
                    v-if="showUserNotActiveInfo"
                >
                    {{ $t('debeActivarCuenta') }}
                </div>
                <div
                    class="alert alert-info"
                    role="alert"
                    v-if="showUserBannedInfo"
                >
                    {{ $t('usuarioBanneado') }}
                </div>

                <!-- Options de connexion -->
                <div class="login-options">
                    <label class="remember-me">
                        <input id="checkbox_remember" type="checkbox" />
                        <span>{{ $t('recordarme') }}</span>
                    </label>
                    <router-link
                        class="forgot-password"
                        :to="{ name: 'reset-password' }"
                    >
                        {{ $t('olvideContra') }}
                    </router-link>
                </div>

                <!-- Bouton de connexion -->
                <button
                    v-jump
                    ref="btn_login"
                    id="btn_login"
                    class="btn btn-login"
                    @click="login"
                    :disabled="loading"
                >
                    <span v-if="!loading">{{ $t('ingresar') }}</span>
                    <spinner class="blue" v-if="loading"></spinner>
                </button>

                <!-- Lien d'inscription -->
                <div class="register-link">
                    {{ $t('noTenesFace') }}
                    <router-link class="register-link-text" :to="{ name: 'register' }">
                        {{ $t('registrateAca') }}
                    </router-link>
                </div>
            </div>

            <!-- Modal d'information -->
            <modal
                :name="'modal'"
                v-if="showModalLogin"
                @close="toggleModalLogin"
                :body="'Body'"
            >
                <template #header><h3>
                    <span>
                        {{ $t('teniasCuentaVinculada') }} {{ modalType === 'facebook' ? $t('facebook') : $t('apple') }}?
                    </span>
                    <i
                        v-on:click="toggleModalLogin"
                        class="fa fa-times float-right-close"
                    ></i>
                </h3></template>
                <template #body><div>
                    <div class="text-left color-black login-modal">
                        <p>
                            {{ $t('ingresoRegistroYaNoFunciona') }} {{ modalType === 'facebook' ? $t('facebook') : $t('apple') }}.
                        </p>
                        <p>
                            {{ $t('escribinosMesaAyuda') }}
                        </p>
                        <p>
                            {{ $t('mesaAyudaFuncionaDesde') }}
                            <a :href="'mailto:' + config.admin_email">
                                {{ config.admin_email }}</a>,
                                {{ $t('mensajePrivadoDe') }} <a href="https://instagram.com/carpoolear">Instagram</a> {{ $t('y') }}
                            <a href="https://facebook.com/carpoolear">Facebook</a>.
                        </p>
                        <p>{{ $t('buenasRutas') }}</p>
                    </div>
                </div></template>
            </modal>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import modal from '../Modal';
import dialogs from '../../services/dialogs.js';
import router from '../../router';
import bus from '../../services/bus-event';
import Spinner from '../Spinner.vue';
import cache from '../../services/cache';

export default {
    name: 'login',
    data() {
        return {
            email: '',
            password: '',
            loading: false,
            fbLoading: false,
            iosLoading: false,
            error: '',
            carpoolear_logo:
                process.env.ROUTE_BASE + 'static/img/carpoolear_logo.png',
            hasScroll: false,
            isUnderstood: true,
            dontShowAgain: false,
            isShowLogin: false,
            showUserNotActiveInfo: false,
            showModalLogin: false,
            modalType: 'facebook',
            showUserBannedInfo: false,
            app_logo:
                process.env.ROUTE_BASE +
                'static/img/' +
                process.env.TARGET_APP +
                '_logo_full.png'
        };
    },
    computed: {
        ...mapGetters({
            checkLogin: 'auth/checkLogin',
            isMobile: 'device/isMobile',
            config: 'auth/appConfig',
            deviceData: 'cordova/device'
        }),
        isDesktop() {
            return !this.isMobile;
        },
        isApple() {
            return true;
            console.log('isApple', window.cordova.platformId);
            return (
                window.cordova &&
                window.cordova.platformId.toLowerCase() === 'ios'
            );
        },
        loginCustomHeader() {
            return this.config ? this.config.login_custom_header : '';
        },
        righPanelclass() {
            if (this.config) {
                if (this.config.trip_card_design === 'light') {
                    return 'col-sm-24 col-md-24';
                } else {
                    return 'col-sm-12 col-md-12';
                }
            } else {
                return 'col-sm-12 col-md-12';
            }
        }
    },
    methods: {
        ...mapActions({
            doLogin: 'auth/login', // map this.add() to this.$store.dispatch('increment')
            fbLogin: 'cordova/facebookLogin',
            appleLogin: 'cordova/appleLogin'
        }),
        fbWarningGetIt() {
            this.isUnderstood = true;
            if (this.dontShowAgain) {
                cache.setItem('fbLoginWarningDontShow', true);
            }
        },
        toggleModalFBLogin() {
            this.modalType = 'facebook';
            this.showModalLogin = !this.showModalLogin;
        },

        toggleModalAppleLogin() {
            this.modalType = 'apple';
            this.showModalLogin = !this.showModalLogin;
        },

        toggleModalLogin(type) {
            if (type) {
                this.modalType = type;
            }
            this.showModalLogin = !this.showModalLogin;
        },
        login() {
            if (!this.fbLoading) {
                this.showUserNotActiveInfo = false;
                this.showUserBannedInfo = false;
                this.loading = true;
                let email = this.email;
                let password = this.password;
                this.doLogin({ email, password }).then(
                    (data) => {
                        this.loading = false;
                        // router.push({ name: 'trips' });
                        // router.rememberBack();
                    },
                    (error) => {
                        const userNotActive =
                            error && error.message === 'user_not_active';
                        const userBanned =
                            error && error.message === 'user_banned';
                        const message = userNotActive
                            ? this.$t('paraIngresarCuenta')
                            : userBanned
                            ? this.$t('usuarioBanneado')
                            : this.$t('emailOContra');
                        this.showUserNotActiveInfo = userNotActive;
                        this.showUserBannedInfo = userBanned;
                        dialogs.message(message, {
                            duration: 10,
                            estado: 'error'
                        });
                        if (error) {
                            this.error = error.error;
                        }
                        this.loading = false;
                    }
                );
            } else {
                dialogs.message(this.$t('solicitudEnviada'), {
                    duration: 10,
                    estado: 'error'
                });
            }
        },
        showLogin() {
            this.isShowLogin = true;
        },

        facebookLogin() {
            if (!this.loading) {
                this.fbLoading = true;
                this.fbLogin().catch((response) => {
                    if (response.errors && response.errors.email) {
                        dialogs.message(this.$t('correoUsado'), {
                            duration: 10,
                            estado: 'error'
                        });
                    }
                });
            } else {
                dialogs.message(this.$t('solicitudEnviada'), {
                    duration: 10,
                    estado: 'error'
                });
            }
        },
        iosLogin() {
            if (!this.loading) {
                this.iosLoading = true;
                this.appleLogin().catch((response) => {
                    if (response.errors && response.errors.email) {
                        dialogs.message(this.$t('correoUsado'), {
                            duration: 10,
                            estado: 'error'
                        });
                    }
                });
            } else {
                dialogs.message(this.$t('solicitudEnviada'), {
                    duration: 10,
                    estado: 'error'
                });
            }
        },
        onClearClick() {
            router.back();
        }
    },

    mounted() {
        bus.on('clear-click', this.onClearClick);
        let viewPort = Math.max(
            document.documentElement.clientHeight,
            window.innerHeight || 0
        );

        if (!this.isMobile) {
            this.$refs.txt_user.focus();
        }

        if (this.config.login_custom_header) {
            this.isShowLogin = true;
        }

        this.hasScroll = document.body.scrollHeight > viewPort;
        cache.getItem('fbLoginWarningDontShow').then((value) => {
            console.log('fbLoginWarningDontShow', value);
            if (value) {
                this.isUnderstood = true;
            }
        });
    },

    beforeDestroy() {
        bus.off('clear-click', this.onClearClick);
    },

    components: {
        Spinner,
        modal
    }
};
</script>

<style>
/* Force le fond vert sur toute la page de login */
body {
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%) !important;
    min-height: 100vh;
}

/* Force également sur l'app-container pour la page login */
.app-container:has(.login-page) {
    min-height: 100vh !important;
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%) !important;
}
</style>

<style scoped>
/* === Layout Principal === */
.login-page {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 30px 20px;
    margin: -85px;
    font-family: 'Heebo', 'Poppins', sans-serif;
    overflow-y: auto;
}

/* Fond vert qui couvre tout */
.login-page::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
    z-index: -1;
}

.login-container {
    width: 100%;
    max-width: 700px;
    min-height: 85vh;
    background: white;
    border-radius: 24px;
    box-shadow: 0 15px 60px rgba(0, 0, 0, 0.15);
    padding: 35px 50px 0px;
    animation: fadeIn 0.5s ease;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* === Header === */
.login-header {
    text-align: center;
    margin-bottom: 28px;
}

.logo-link {
    text-decoration: none;
}

.app-name {
    font-family: 'Poppins', sans-serif;
    font-size: 48px;
    font-weight: 700;
    color: #59c362;
    margin: 0 0 12px 0;
    letter-spacing: -0.5px;
    transition: all 0.3s ease;
}

.logo-link:hover .app-name {
    color: #48a551;
    transform: scale(1.02);
}

.login-subtitle {
    font-size: 20px;
    font-weight: 400;
    color: #666;
    margin: 0;
}

/* === Formulaire === */
.login-form {
    width: 100%;
}

.form-group {
    margin-bottom: 24px;
}

.form-group label {
    display: block;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
    font-family: 'Heebo', sans-serif;
}

.form-input {
    width: 100%;
    height: 58px;
    border-radius: 12px;
    border: 2px solid #d0d0d0;
    padding: 16px 20px;
    font-size: 16px;
    font-weight: 500;
    font-family: 'Heebo', sans-serif;
    color: #333;
    background: white;
    transition: all 0.3s ease;
    box-sizing: border-box;
}

.form-input:focus {
    outline: none;
    border-color: #59c362;
    box-shadow: 0 2px 12px rgba(89, 195, 98, 0.2);
}

.form-input::placeholder {
    color: #999;
    font-weight: 400;
}

/* === Options de connexion === */
.login-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 28px;
    font-size: 15px;
}

.remember-me {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    margin: 0;
    font-weight: 400;
    color: #555;
}

.remember-me input[type="checkbox"] {
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin: 0;
}

.forgot-password {
    color: #59c362;
    font-weight: 600;
    text-decoration: none;
    transition: color 0.3s ease;
}

.forgot-password:hover {
    color: #48a551;
    text-decoration: underline;
}

/* === Bouton de connexion === */
.btn-login {
    width: 100%;
    height: 60px;
    background: linear-gradient(135deg, #59c362 0%, #48a551 100%);
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 18px;
    font-weight: 700;
    font-family: 'Heebo', sans-serif;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(89, 195, 98, 0.3);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.btn-login:hover:not(:disabled) {
    background: linear-gradient(135deg, #48a551 0%, #3d8f44 100%);
    box-shadow: 0 6px 16px rgba(89, 195, 98, 0.4);
    transform: translateY(-2px);
}

.btn-login:active:not(:disabled) {
    transform: translateY(0);
}

.btn-login:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* === Lien d'inscription === */
.register-link {
    text-align: center;
    margin: 28px 0 22px 0;
    font-size: 15px;
    color: #666;
}

.register-link-text {
    color: #59c362;
    font-weight: 700;
    text-decoration: none;
    transition: color 0.3s ease;
    margin-left: 5px;
}

.register-link-text:hover {
    color: #48a551;
    text-decoration: underline;
}

/* === Séparateur === */
.separator {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 22px 0;
    color: #999;
    font-size: 14px;
    font-weight: 500;
}

.separator::before,
.separator::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #e0e0e0;
}

.separator span {
    padding: 0 15px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* === Boutons sociaux === */
.social-buttons {
    display: flex;
    gap: 16px;
    margin-top: 22px;
}

.btn-social {
    flex: 1;
    height: 58px;
    border-radius: 12px;
    border: 2px solid #d0d0d0;
    background: white;
    color: #333;
    font-size: 16px;
    font-weight: 600;
    font-family: 'Heebo', sans-serif;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.btn-social i {
    font-size: 22px;
}

.btn-facebook {
    border-color: #1877f2;
    color: #1877f2;
}

.btn-facebook:hover:not(:disabled) {
    background: #1877f2;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(24, 119, 242, 0.3);
}

.btn-apple {
    border-color: #000;
    color: #000;
}

.btn-apple:hover:not(:disabled) {
    background: #000;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.btn-social:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* === Alertes === */
.alert {
    border-radius: 10px;
    padding: 12px 15px;
    margin-bottom: 16px;
    font-size: 14px;
    line-height: 1.5;
}

.alert-warning {
    background: #fff3cd;
    border: 1px solid #ffc107;
    color: #856404;
}

.alert-info {
    background: #d1ecf1;
    border: 1px solid #17a2b8;
    color: #0c5460;
}

.alert-warning a {
    color: #856404;
    font-weight: 600;
    text-decoration: underline;
}

/* === Warning Login Form === */
.form-warning-login {
    margin-top: 15px;
}

.form-warning-login label {
    color: #333;
    font-weight: 500;
}

.form-warning-login .checkbox {
    display: inline-block;
    margin-right: 10px;
}

.form-warning-login .checkbox span {
    text-transform: none;
}

.form-warning-login button {
    background: #59c362;
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.form-warning-login button:hover {
    background: #48a551;
}

/* === Modal === */
.login-modal p {
    margin-bottom: 15px;
    line-height: 1.6;
}

.login-modal a {
    color: #59c362;
    font-weight: 600;
    text-decoration: none;
}

.login-modal a:hover {
    text-decoration: underline;
}

/* === Responsive === */
@media only screen and (max-width: 768px) {
    .login-page {
        min-height: 100vh;
        padding: 20px 15px;
    }

    .login-container {
        padding: 35px 30px;
        border-radius: 18px;
        margin: 0;
        min-height: auto;
    }

    .app-name {
        font-size: 38px;
    }

    .login-subtitle {
        font-size: 18px;
    }

    .form-group {
        margin-bottom: 18px;
    }

    .form-input {
        height: 54px;
        font-size: 15px;
    }

    .btn-login {
        height: 56px;
        font-size: 16px;
    }

    .social-buttons {
        flex-direction: column;
    }

    .btn-social {
        width: 100%;
    }

    .separator span {
        font-size: 12px;
    }
}

@media only screen and (max-width: 420px) {
    .login-page {
        padding: 15px 12px;
        min-height: 100vh;
    }

    .login-container {
        padding: 30px 25px;
        min-height: auto;
    }

    .app-name {
        font-size: 32px;
    }

    .login-options {
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
    }
}

/* === Animations supplémentaires === */
.form-input,
.btn-login,
.btn-social,
.forgot-password,
.register-link-text {
    position: relative;
}

@media (prefers-reduced-motion: no-preference) {
    .btn-login:hover:not(:disabled),
    .btn-social:hover:not(:disabled) {
        animation: pulse 0.6s ease-in-out;
    }
}

@keyframes pulse {
    0%, 100% {
        transform: translateY(-2px) scale(1);
    }
    50% {
        transform: translateY(-2px) scale(1.02);
    }
}
</style>
